module.exports = __webpack_public_path__ + "static/assets/f197a5756552118c132f63fc9dce21d4.gif";